var render = function render(){var _vm=this,_c=_vm._self._c;return (this.ppadmin_data)?_c('div',{attrs:{"id":"Cooperation"}},[_c('div',{staticClass:"content container",domProps:{"innerHTML":_vm._s(_vm.cooperation)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }